/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![NintendoSwitchNeutralIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABeUlEQVR4nN2VzytEURTH3x9gZS2FncRCYm2h9N75cafuO6exsvFnSEpR/gGsWbBhKYPCUlkrZY1Y+Vm80ZmGZpo3M2bmlTh16tb5vvM5597XOUHw7wzA9yHLKpKcAst5pSPromkilqnqmJ4g63IU+d6GydGJB9JnZC0C6zWSHALrQclJ34F103REkjdNij8BSy41eejiESB9A9LLyMVjNXC2j5sCzF8BdLi2etJtCyL6wdTu+MeAouVKSSB3wHpsZ2YZAJYdE4a5fH8bgNu0ChNg2SifCxXi/ZYBrEkawAJrdi7/MV+AszYAxcYAF08Ay4WBmPOjmQM6fmTOCAAkH4jxrPe+C5xOAul9th2Q7lZrZD7bDlj2KjVAspD5FQHLnPe+O2KZRpaHX33kBEjWMwIk9UbFURYAILmpO+xCFw913AHJVk0CG7GlUUt6hajjbQNIXuoVGSCqQ5bH74XDWmh14ViOoJE5N9ODrEs2ultbmbLSdGX+SfsERe33cU/2JyMAAAAASUVORK5CYII=)
 */
export const NintendoSwitchNeutralIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M10.04 20.25H7.12a3.5 3.5 0 0 1-2.48-1.03A3.37 3.37 0 0 1 3.6 16.8V7.21a3.48 3.48 0 0 1 3.52-3.45h2.92v16.49ZM11.5 2.18H7.12A5.08 5.08 0 0 0 2 7.2v9.58c0 2.78 2.3 5.03 5.12 5.03h4.38c.08 0 .15-.06.15-.14V2.32c0-.08-.07-.14-.15-.14ZM5.1 8.07c0 1.02.85 1.85 1.89 1.85s1.88-.83 1.88-1.85S8.03 6.22 7 6.22s-1.88.83-1.88 1.85ZM17.6 11a2 2 0 0 1 2.02 1.98 2 2 0 0 1-2.01 2 2 2 0 0 1-2.03-2A2 2 0 0 1 17.61 11ZM13.8 21.82h3.09A5.08 5.08 0 0 0 22 16.8V7.21c0-2.78-2.3-5.03-5.12-5.03h-3.1c-.07 0-.13.05-.13.12v19.38c0 .08.06.14.14.14Z"
        className={colorClass}
      />
    </svg>
  );
};
